export enum DeviceTypeEnum {
    Web = "Web",
    Desktop = "Desktop",
    Mobile = "Mobile",
    ChromeExtension = "ChromeExtension"
}